<template>
	<a-layout-header  class="userinfo">
		<a-row type="flex" justify="end" >
			<a-space class="name" :size='12'>
				<a-icon class="icon" type="user" />
				<span class="info">{{user.enterpriseFullName}}</span>
			</a-space>
			<a-button class="link" type="link" @click="handlerLogout"><a-icon type="logout" :rotate="270" /></a-button>
		</a-row>
	</a-layout-header>
</template>

<script>
	export default{
		name: 'HinaUserInfo',
		props: {
			user:{
				type: Object,
				default: () => {}
			}
		},
		methods: {
			handlerLogout: function(){
				this.$post('enterpriseInformation/logout').then(res => {
					localStorage.clear()
					let objTemp = {
						token: {
							access: '',
							refresh: ''
						},
						enterpriseInformation: {
							id: '',
							corporateAccount: '',
							enterpriseFullName: '',
							enterpriseAbbreviation: '',
							businessLicenseNumber: '',
							address: '',
							enterpriseContact: '',
							enterpriseContactNumber: '',
							accumulatedRechargeAmount: '',
							enterpriseCurrentBalance: '',
							legalRepresentativeName: '',
							contactNumber: ''
						}
					}
					this.$store.dispatch('actUserCode', objTemp.token)
					this.$store.dispatch('actUserInfo', objTemp.enterpriseInformation)
					this.$router.replace({ path: '/login'})
				})
			}
		}


	}
</script>


<style lang="scss" scoped>
	.userinfo{
		color: #FFF;
		background: #001529; padding: 0;
		.name{
			height: 64px;
			margin: 0 12px 0 0;
			display: flex;
			justify-content: center;
			align-items: center;
			.icon{
				padding: 24px 0 0;
				height: 48px !important;
				line-height: 24px !important;
				font-size: 24px;
				overflow: hidden;
			}
			.info{
				line-height: 64px;
				font-size: 20px;
				display: block;
				max-width: 240px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}
		.link{
			color: #FFF;
			height: 64px;
			line-height: 64px;
			font-size: 18px;
		}
	}
</style>
